export default "__VITE_ASSET__2ab0d767__"